import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { AppConstants } from '../app_setting/app-constants';

@Injectable({
  providedIn: 'root'
})

export class PrincipalService extends BaseService {
  getListPrincipal(src: string, lim: number, off: number, sort: string, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`/principal?src=${src}&lim=${lim}&off=${off}&sort=${sort}`)
        .subscribe(
            resp => {
                if (resp.alert.code === 200) {
                    onSuccess(resp.data);
                  } else {
                    onError(resp.alert);
                  }
            },
            err => {
               if (onError) {
                   onError(err);
               }
            });
      }

  getPrincipalHighlighted(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get('/principal/highlight')
        .subscribe(
            resp => {
               onSuccess(resp.data);
            },
            err => {
               if (onError) {
                   onError(err);
               }
            });
      }

  getPrincipal(keyword: string, limit: number, offset: number, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`principal?src=${keyword}&lim=${limit}&off=${offset}`)
        .subscribe(
            resp => {
                onSuccess(resp.data);
            },
            err => {
                if (onError) {
                    onError(err);
                }
            });
      }
  setImagePrincipal(imageUrl: string): string {

    if (imageUrl === null || imageUrl === '' || imageUrl === undefined){
      return AppConstants.NoImageDefault;
    }

    return imageUrl;
}
}